import PropTypes from 'prop-types'
import {Flex, Box, Radio, Text} from '@chakra-ui/react'

const DropdownRadioCards = ({options, value, onChange}) => {
  return (
    <Flex direction="column" gap={4}>
      {options.map((option) => (
        <Box
          key={option.value}
          borderWidth="1px"
          borderRadius="md"
          borderColor="mld.neutral.500"
          p={3}
        >
          <Radio
            value={option.value}
            isChecked={value === option.value}
            onChange={onChange}
            mb={value === option.value ? 4 : 0}
            variant="mld"
            _hover={{}}
          >
            {typeof option.title === 'string' ? (
              <Text fontSize="16px">{option.title}</Text>
            ) : (
              option.title
            )}
          </Radio>

          {value === option.value && option.children && (
            <Box ml={6}>{option.children}</Box>
          )}
        </Box>
      ))}
    </Flex>
  )
}

DropdownRadioCards.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      children: PropTypes.node,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default DropdownRadioCards
